import Analytics from '@web/services/Analytics/Analytics'

export function hwPageView (homeworkId: string): void {
  Analytics.send({
    action: 'page_view',
    homework_id: homeworkId
  })
}

export function hwSubmitSuccess (homeworkId: string): void {
  Analytics.send({
    action: 'homework_submit_success',
    homework_id: homeworkId
  })
}
